import { isDraftSaveAction } from '../../../../Draft'
import { FormModalConfirmation } from '../../../../Form'
import { RentalPortalApplicantDraftCloseActionSelectModal } from '../../RentalPortalApplicantDraftCloseActionSelectModal'
import { useRentalPortalApplicantDraft } from '../useRentalPortalApplicantDraft'

export function useRentalPortalApplicantFormCloseConfirmation({
  onClose,
  onSubmitConfirm,
}) {
  const { draftId, setDraft } = useRentalPortalApplicantDraft()

  function handleSubmitConfirm(values, files, action) {
    setDraft(isDraftSaveAction(action) ? values : null, 0)

    onSubmitConfirm?.(values, files, action)
    onClose()
  }

  return {
    Confirmation: draftId
      ? RentalPortalApplicantDraftCloseActionSelectModal
      : FormModalConfirmation,
    handleSubmitConfirm,
  }
}
